import { useMemo } from "preact/hooks";
import { donors, rewards, targets } from "@/data/example/index.js";
import { isYes } from "@/util/common.js";

/**
 *
 * @param config
 * @returns {{demoMilestones: import('@playlive/tiltify-lib').TiltifyMilestone[], demoRewards: import('@playlive/tiltify-lib').TiltifyReward[], demoTargets: import('@playlive/tiltify-lib').TiltifyTarget[], demoDonations: import('@playlive/tiltify-lib').TiltifyDonation[]}}
 */
export default function useDemoProgressBarData(config) {
  /**
   * @type {import('@playlive/tiltify-lib').TiltifyDonation[]}
   */
  const demoDonations = useMemo(() => {
    return isYes(config.showDonors)
      ? donors.map((d) => {
          return {
            completed_at: new Date().toISOString(),
            id: d.id,
            donor_name: d.name,
            color: config.textColor,
            amount: {
              value: d.amount,
            },
          };
        })
      : [];
  }, [config.showDonors, config.textColor]);

  /**
   * @type {import('@playlive/tiltify-lib').TiltifyReward[]}
   */
  const demoRewards = useMemo(() => {
    return (isYes(config.showRewards) ? rewards : []).map((r) => {
      return {
        active: true,
        id: r.id,
        name: r.name,
        color: config.textColor,
        amount: {
          value: r.amount.value,
          currency: "USD",
        },
        highlighted: false,
        ends_at: null,
        updated_at: new Date().toISOString(),
        starts_at: null,
        legacy_id: 1,
        inserted_at: new Date().toISOString(),
        image: null,
        description: null,
        fair_market_value: null,
        quantity: null,
        quantity_remaining: null,
      };
    });
  }, [config.showRewards, config.textColor]);

  /**
   * @type {import('@playlive/tiltify-lib').TiltifyTarget[]}
   */
  const demoTargets = useMemo(() => {
    return (isYes(config.showChallenges) ? targets : []).map((t) => {
      return {
        active: true,
        id: t.id,
        name: t.name,
        color: config.textColor,
        legacy_id: 1,
        amount: {
          value: t.amount,
          currency: "USD",
        },
        ends_at: new Date().toISOString(),
        inserted_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        amount_raised: {
          value: t.amount,
          currency: "USD",
        },
      };
    });
  }, [config.showChallenges, config.textColor]);

  /**
   * @type {import('@playlive/tiltify-lib').TiltifyMilestone[]}
   */
  const demoMilestones = useMemo(
    () => [
      {
        id: Date.now().toString(),
        active: true,
        inserted_at: new Date().toISOString(),
        name: "The Milestone",
        legacy_id: 1,
        updated_at: new Date().toISOString(),
        amount: {
          value: "1000",
          currency: "USD",
        },
      },
      {
        id: Date.now().toString(),
        active: true,
        inserted_at: new Date().toISOString(),
        name: "The Milestone 2",
        legacy_id: 2,
        updated_at: new Date().toISOString(),
        amount: {
          value: "2000",
          currency: "USD",
        },
      },
      {
        id: Date.now().toString(),
        active: true,
        inserted_at: new Date().toISOString(),
        name: "The Milestone 3",
        legacy_id: 3,
        updated_at: new Date().toISOString(),
        amount: {
          value: "3000",
          currency: "USD",
        },
      },
    ],
    [],
  );

  return {
    demoMilestones,
    demoRewards,
    demoTargets,
    demoDonations,
  };
}
